import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'


//--- Estilos e íconos de Bootstrap ---//
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './styles/styles.css'
//--- Estilos e íconos de Bootstrap ---//


//--- Páginas del aspirante ---//
import { Login } from './components/Login/Login'
import { SignUp } from './components/Applicants/SignUp'
import { RegisteredApplicant } from './components/Applicants/RegisteredApplicant'
import { ReprintReceipt } from './components/Applicants/ReprintReceipt'
//--- Páginas del aspirante ---//


function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Páginas de Aspirantes */}
          <Route
            path='/'
            element={<Login />}
          />
          <Route
            path='/signup'
            element={<SignUp />} 
          />
          <Route
            path='/registered-applicant'
            element={<RegisteredApplicant />}
          />
          <Route
            path='/reprint-receipt'
            element={<ReprintReceipt />}
          />
        </Routes>
      </Router>
    </>
  )
}

export default App;